import { trackUserEvent } from '../../analytics';
import type { ZrmClickstreamUserOrUndefined } from '../../analytics/types';
import { SEMANTIC_EVENT_NAME, TOPIC_TAG_TXT, TRIGGER_LOCATION, TRIGGER_TYPE } from './globals';
import { getZrmUserInfo } from '@zg-rentals/clickstream';

const SEND_BUTTON = 'send_button';

// https://dataportal.zillowgroup.net/event-registry/3383
export const emitSendMessageSmsAsSourceEvent = (user: ZrmClickstreamUserOrUndefined) =>
  trackUserEvent({
    envelope: {
      event_type_id: '3383',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.RachelInbox,
      trigger_source_nm: SEND_BUTTON,
      trigger_object_nm: 'reply_sms_as_source',
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ReplyMessage,
      topic_tag_txt: [TOPIC_TAG_TXT.RachelSatellite],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3384
export const emitSendMessageWithAttachmentsEvent = (user: ZrmClickstreamUserOrUndefined) =>
  trackUserEvent({
    envelope: {
      event_type_id: '3384',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.RachelInbox,
      trigger_source_nm: SEND_BUTTON,
      trigger_object_nm: 'reply_with_attachments',
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ReplyMessage,
      topic_tag_txt: [TOPIC_TAG_TXT.RachelSatellite],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3385
export const SEND_MESSAGE_EVENT_TYPE_ID = '3385';
export const emitSendMessageEvent = (user: ZrmClickstreamUserOrUndefined) =>
  trackUserEvent({
    envelope: {
      event_type_id: SEND_MESSAGE_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.RachelInbox,
      trigger_source_nm: SEND_BUTTON,
      trigger_object_nm: 'reply',
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ReplyMessage,
      topic_tag_txt: [TOPIC_TAG_TXT.RachelSatellite],
    },
    ...getZrmUserInfo(user),
  });
